import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";
import { TOTAL_COST } from "./formula-total-cost";
import { UNITS } from "./formula-units";

/**
 //  * Formulas for Metrics
 //  *
 //  * @param factoryOptions
 //  *  - provided to `metricsValueGetterCreator`
 //  *  - untyped, easily allow for custom inputs needed for calculation
 //  * @param getterParams
 //  *  - default getterParams from AgGrid
 //  *  - has context and data etc to facilitate calculation
 //  * @returns
 //  *  - a numerical caculated metrics value
 //  */
export const AVERAGE_COST = ({ factoryOptions, getterParams }) => {
    const totalCost = referenceMetricValueOrCompute(
        () => TOTAL_COST({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.TOTAL_COST
    );
    const totalUnits = referenceMetricValueOrCompute(
        () => UNITS({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.UNITS
    );

    if (totalUnits && totalCost) {
        return totalCost / totalUnits;
    }

    return undefined;
};
